// SocietyList.js (fixed design)
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "react-perfect-scrollbar/dist/css/styles.css";
import { getSociety } from "./APIs/CreateSocietyApi";
import { CSVLink } from "react-csv";
import axios from "axios";
import { BASE_URL } from "./APIs/config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { FiSearch, FiDownload, FiEdit2, FiTrash2, FiX } from "react-icons/fi";

const csvHeaders = [
  { label: "SOCIETY NAME", key: "societyName"  },
  { label: "SOCIETY AREA", key: "societyArea" },
  { label: "SOCIETY REGISTRATION NO", key: "societyRegistrationNo" },
  { label: "AREA REGISTRATION NO", key: "reraRegistrationNo" },
  { label: "SOCIETY EMAIL", key: "societyEmail" },
  { label: "SOCIETY PHONE NO.", key: "contactPersonPhoneNo" },
  { label: "STATE", key: "state" },
  { label: "PIN CODE", key: "pinCode" },
  { label: "CONTACT PERSON", key: "contactPerson" },
  { label: "CONTACT PERSON PHONE NO", key: "contactPersonPhoneNo" },
];

export default function SocietyList() {
  const navigate = useNavigate();
  const [societies, setSocieties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState(null);
  const firstInputRef = useRef(null);
  const [enabledMap, setEnabledMap] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadSocieties();
  }, []);

  const loadSocieties = async () => {
    setLoading(true);
    try {
      const data = await getSociety();
      const societiesArray = Array.isArray(data) ? data : [];
      setSocieties(societiesArray);
      const initialEnabledMap = {};
      societiesArray.forEach((s) => {
        initialEnabledMap[s.societyId] = !!s.accessSociety;
      });
      setEnabledMap(initialEnabledMap);
    } catch (err) {
      console.error("Failed to load societies:", err);
      toast.error("Failed to load societies.");
    } finally {
      setLoading(false);
    }
  };

  const openModal = (item) => {
    const copy = {
      societyId: item.societyId ?? item.societyId,
      societyName: item.societyName ?? "",
      societyArea: item.societyArea ?? "",
      societyAddress: item.societyAddress ?? "",
      societyAddress2: item.societyAddress2 ?? "",
      societyAddress3: item.societyAddress3 ?? "",
      societyRegistrationNo: item.societyRegistrationNo ?? "",
      reraRegistrationNo: item.reraRegistrationNo ?? "",
      societyEmail: item.societyEmail ?? "",
      contactPersonPhoneNo: item.contactPersonPhoneNo ?? "",
      contactPerson: item.contactPerson ?? "",
      pinCode: item.pinCode ?? "",
      state: item.state ?? "",
      isContactYes: !!item.isContactYes || false,
      isContactNo: !!item.isContactNo || false,
      ...item,
    };
    setFormData(copy);
    setIsModalOpen(true);
    setTimeout(() => firstInputRef.current?.focus(), 0);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setFormData(null);
  };

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!formData) return;

    setSaving(true);

    try {
      const token = localStorage.getItem("token");

      if (!token) {
        toast.error("Not authenticated. Please login and try again.", {
          position: "bottom-right",
          autoClose: 3000,
        });
        setSaving(false);
        return;
      }

      // Create URLSearchParams (form-encoded) instead of JSON
      const payload = new URLSearchParams();

      // Add societyNameId (this is required by the backend)
      if (formData.societyId !== undefined && formData.societyId !== null) {
        payload.append("societyNameId", String(formData.societyId));
      }

      // Add all other fields
      payload.append("societyName", formData.societyName ?? "");
      payload.append("societyArea", formData.societyArea ?? "");
      payload.append("societyAddress", formData.societyAddress ?? "");
      payload.append("societyAddress2", formData.societyAddress2 ?? "");
      payload.append("societyAddress3", formData.societyAddress3 ?? "");
      payload.append(
        "societyRegistrationNo",
        formData.societyRegistrationNo ?? "",
      );
      payload.append("reraRegistrationNo", formData.reraRegistrationNo ?? "");
      payload.append("societyEmail", formData.societyEmail ?? "");
      payload.append("state", formData.state ?? "");
      payload.append("pinCode", formData.pinCode ?? "");
      payload.append("contactPerson", formData.contactPerson ?? "");
      payload.append(
        "contactPersonPhoneNo",
        formData.contactPersonPhoneNo ?? "",
      );

      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      };

      const res = await axios.post(
        `${BASE_URL}/api1/update-society-id`,
        payload.toString(),
        { headers },
      );

      const updated = res?.data ?? formData;

      // Update local state
      setSocieties((prev) =>
        prev.map((s) =>
          s.societyId === formData.societyId ? { ...s, ...updated } : s,
        ),
      );

      await loadSocieties();
      closeModal();
      toast.success("Society updated successfully.", {
        position: "bottom-right",
        autoClose: 3000,
      });
    } catch (err) {
      console.error("Save failed:", err);

      const serverMsg =
        err?.response?.data?.message ||
        (typeof err?.response?.data === "string" ? err.response.data : null) ||
        err?.message ||
        "Unknown error";

      if (err.response) {
        console.error("Response status:", err.response.status);
        console.error("Response data:", err.response.data);

        if (err.response.status === 403) {
          toast.error("Authorization failed (403). Please login again.", {
            position: "bottom-right",
            autoClose: 4000,
          });
        } else if (err.response.status === 400) {
          toast.error(`Bad request (400). ${serverMsg}`, {
            position: "bottom-right",
            autoClose: 4000,
          });
        } else {
          toast.error(`Server returned ${err.response.status}: ${serverMsg}`, {
            position: "bottom-right",
            autoClose: 4000,
          });
        }
      } else if (err.request) {
        toast.error(
          "No response from server — check network or server status.",
          { position: "bottom-right", autoClose: 4000 },
        );
      } else {
        toast.error(`Error: ${serverMsg}`, {
          position: "bottom-right",
          autoClose: 4000,
        });
      }
    } finally {
      setSaving(false);
    }
  };

  const enableSociety = async (societyId, societyName, isAccess) => {
    try {
      const response = await fetch(
        `${BASE_URL}/api1/enable-society-by-super-admin?societyId=${societyId}&societyName=${encodeURIComponent(
          societyName,
        )}&isAccess=${isAccess}`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      );

      if (!response.ok) throw new Error("Failed to enable society");
      toast.success(`Society ${isAccess ? "Enabled" : "Disabled"}`, {
        position: "bottom-right",
        autoClose: 2000,
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to update status", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };

  const handleDeleteSociety = async (adminId, societyName) => {
    if (!window.confirm(`Delete society "${societyName}"?`)) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${BASE_URL}/delete/delete-table-by-society-name`, {
        params: { societyId: adminId, societyName: societyName },
        headers: { Authorization: `Bearer ${token}` },
      });
      setSocieties((prev) => prev.filter((s) => s.societyId !== adminId));
      toast.success("Society deleted.", {
        position: "bottom-right",
        autoClose: 3000,
      });
    } catch (err) {
      toast.error("Failed to delete society.", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };

  // Filter societies
  const filteredSocieties = societies.filter(
    (s) =>
      s?.societyName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      s?.societyArea?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="flex min-h-screen bg-bg-primary text-text-main font-satoshi transition-colors duration-300">
      <Sidebar />

      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        <Header />

        <div className="flex-1 overflow-y-auto p-6 md:p-8 relative">
          {/* Background Elements */}
          <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden opacity-30">
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-900/10 rounded-full blur-[100px]"></div>
            <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-purple-900/10 rounded-full blur-[100px]"></div>
          </div>

          <div className="relative z-10 max-w-7xl mx-auto space-y-6">
            {/* Actions Toolbar */}
            <div className="flex flex-col md:flex-row justify-between items-end md:items-center gap-4 border-b border-border pb-6">
              <div>
                <h1 className="text-3xl font-clash font-bold text-text-main mb-1">
                  Societies Directory
                </h1>
                <p className="text-text-muted text-sm">
                  Manage registered societies and their access permissions
                </p>
              </div>

              <div className="flex items-center gap-3">
                <div className="relative group">
                  <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted group-focus-within:text-signal-orange transition-colors" />
                  <input
                    type="text"
                    placeholder="Search societies..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10 pr-4 py-2 bg-bg-secondary border border-border rounded focus:border-signal-orange focus:outline-none text-sm w-64 transition-all text-text-main placeholder:text-text-muted"
                  />
                </div>
                <CSVLink
                  data={societies}
                  headers={csvHeaders}
                  filename="society-data.csv"
                >
                  <button className="flex items-center gap-2 px-4 py-2 bg-bg-secondary hover:bg-bg-tertiary border border-border rounded text-sm font-medium transition-all group text-text-main">
                    <FiDownload className="group-hover:text-signal-lime" />
                    <span>Export</span>
                  </button>
                </CSVLink>
              </div>
            </div>

            {/* List Content */}
            <div className="bg-bg-secondary rounded border border-border overflow-hidden backdrop-blur-sm">
              {/* Header Row */}
              <div className="grid grid-cols-12 gap-4 p-4 border-b border-border bg-bg-tertiary/50 text-xs font-bold text-text-muted uppercase tracking-wider">
                <div className="col-span-3">Society Details</div>
                <div className="col-span-3">Location</div>
                <div className="col-span-2">Contact</div>
                <div className="col-span-2">Status</div>
                <div className="col-span-2 text-right">Actions</div>
              </div>

              {/* Rows */}
              <div className="divide-y divide-border">
                {loading ? (
                  <div className="p-8 text-center text-text-muted animate-pulse">
                    Loading directory...
                  </div>
                ) : filteredSocieties.length === 0 ? (
                  <div className="p-8 text-center text-text-muted">
                    No societies found matching your search.
                  </div>
                ) : (
                  filteredSocieties.map((s, i) => (
                    <div
                      key={s.societyId || i}
                      className="grid grid-cols-12 gap-4 p-4 items-center hover:bg-bg-tertiary transition-colors group"
                    >
                      <div className="col-span-3">
                        <div
                          className="font-medium text-text-main group-hover:text-signal-orange transition-colors cursor-pointer"
                          onClick={() => openModal(s)}
                        >
                          {s.societyName || "Unnamed Society"}
                        </div>
                        <div className="text-xs text-text-muted mt-0.5">
                          {s.societyRegistrationNo || "No Reg. No"}
                        </div>
                      </div>

                      <div className="col-span-3 text-sm text-text-muted">
                        <div>{s.societyArea}</div>
                        <div className="text-xs">
                          {s.state}, {s.pinCode}
                        </div>
                      </div>

                      <div className="col-span-2 text-sm text-text-muted">
                        <div>{s.contactPersonPhoneNo || "N/A"}</div>
                        <div
                          className="text-xs truncate"
                          title={s.societyEmail}
                        >
                          {s.societyEmail}
                        </div>
                      </div>

                      <div className="col-span-2">
                        <button
                          onClick={() => {
                            const newState = !enabledMap[s.societyId];
                            setEnabledMap((prev) => ({
                              ...prev,
                              [s.societyId]: newState,
                            }));
                            enableSociety(s.societyId, s.societyName, newState);
                          }}
                          className={`flex items-center gap-2 px-2 py-1 rounded text-xs font-medium border transition-colors ${enabledMap[s.societyId] ? "border-signal-lime/30 bg-signal-lime/10 text-green-400" : "border-red-500/30 bg-red-500/10 text-red-500"}`}
                        >
                          <span
                            className={`w-1.5 h-1.5 rounded-full ${enabledMap[s.societyId] ? "bg-green-400" : "bg-red-500"}`}
                          ></span>
                          {enabledMap[s.societyId] ? "Active" : "Disabled"}
                        </button>
                      </div>

                      <div className="col-span-2 flex justify-end gap-2 opacity-60 group-hover:opacity-100 transition-opacity">
                        <button
                          onClick={() => openModal(s)}
                          className="p-2 hover:bg-bg-tertiary rounded text-blue-400 transition-colors"
                          title="Edit"
                        >
                          <FiEdit2 />
                        </button>
                        <button
                          onClick={() =>
                            handleDeleteSociety(s.societyId, s.societyName)
                          }
                          className="p-2 hover:bg-bg-tertiary rounded text-red-400 transition-colors"
                          title="Delete"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      {isModalOpen && formData && (
        // NEW CODE:
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-bg-primary/80 backdrop-blur-sm">
          <div className="bg-bg-secondary border border-border w-full max-w-3xl rounded-lg shadow-2xl overflow-hidden animate-reveal">
            <div className="flex justify-between items-center p-6 border-b border-border">
              <h2 className="text-xl font-clash font-bold text-text-main">
                Edit Society Details
              </h2>
              <button
                onClick={closeModal}
                className="text-text-muted hover:text-text-main transition-colors"
              >
                <FiX size={24} />
              </button>
            </div>

            <form
              onSubmit={onSubmit}
              className="p-6 overflow-y-auto max-h-[70vh]"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Fields Generator */}
                {[
                  { label: "Society Name", key: "societyName", required: true, disabled: true},
                  { label: "Area", key: "societyArea", required: true, disabled: true },
                  { label: "Registration No", key: "societyRegistrationNo", disabled: true },
                  { label: "RERA No", key: "reraRegistrationNo", disabled: true },
                  {
                    label: "Address Line 1",
                    key: "societyAddress",
                    required: true,
                  },
                  { label: "Address Line 2", key: "societyAddress2" },
                  { label: "Address Line 3", key: "societyAddress3" },
                  { label: "State", key: "state" },
                  { label: "Pin Code", key: "pinCode" },
                  { label: "Email", key: "societyEmail", type: "email" },
                  { label: "Contact Person", key: "contactPerson" },
                  { label: "Phone", key: "contactPersonPhoneNo" },
                ].map((field) => (
                  <div key={field.key} className="space-y-1">
                    <label className="text-xs font-bold text-text-muted uppercase tracking-wider">
                      {field.label}{" "}
                      {field.required && (
                        <span className="text-signal-orange">*</span>
                      )}
                    </label>
                    <input
                      ref={field.key === "societyName" ? firstInputRef : null}
                      type={field.type || "text"}
                      value={formData[field.key] || ""}
                      onChange={(e) => handleChange(field.key, e.target.value)}
                      required={field.required}
                       disabled={field.disabled}
                      className="w-full bg-bg-input border border-border rounded px-3 py-2 text-text-main focus:border-signal-orange focus:outline-none transition-colors placeholder:text-text-muted"
                    />
                  </div>
                ))}
              </div>

              <div className="mt-8 flex justify-end gap-4 border-t border-border pt-6">
                <button
                  type="button"
                  onClick={closeModal}
                  className="px-4 py-2 text-text-muted hover:text-text-main transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={saving}
                  className="px-6 py-2 bg-signal-orange text-noir-900 font-bold rounded hover:bg-orange-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {saving ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
